export const environment = {
  production: true,
  hmr: false,
  apiUrl: '/tuf-server/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts